import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  tags: [],
  fetchLoading: false,
};

const slice = createSlice({
  name: "tags",
  tags: [],
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // FETCH  LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.fetchLoading = false;
    },

    // TODO: success post blog

    postTagsuccess(state, action) {
      state.isLoading = false;
    },

    getTagsSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.tags = action.payload;
    },

    resetTagSuccess(state) {
      state.tags = [];
    },
  },
});

export default slice.reducer;

export function postTags({ enqueueSnackbar, tagData }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`tags`, tagData);
      dispatch(slice.actions.postTagsuccess(response.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: reset
export function resetTags() {
  return (dispatch) => {
    dispatch(slice.actions.resetTagSuccess());
  };
}

export function updateTags({ enqueueSnackbar, tagData, tag_id }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`tags/${tag_id}`, tagData);
      dispatch(slice.actions.postTagsuccess(response.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTagsOfItem({ item_id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`tags?item_id=${item_id}`);
      dispatch(slice.actions.getTagsSuccess(response.data.data));
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}
